let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kpvyr")).then(() => parcelRequire('fx0K9'));